export default "__VITE_PUBLIC_ASSET__c6963f35__"